module.exports = __webpack_public_path__ + "img/Agente.47adfe66.jpeg";